export const projectTools = [
  {
    id: 1,
    title: "Laravel",
    image: require("../assets/images/services/tools_laravel.png"),
  },
  {
    id: 2,
    title: "golang",
    image: require("../assets/images/services/tools_go.png"),
  },
  {
    id: 3,
    title: "node JS",
    image: require("../assets/images/services/tools_node.png"),
  },
  {
    id: 4,
    title: "nuxt JS",
    image: require("../assets/images/services/tools_nuxt.png"),
  },
  {
    id: 5,
    title: "postgreSQL",
    image: require("../assets/images/services/tools_postgreSQL.png"),
  },
  {
    id: 6,
    title: "react JS",
    image: require("../assets/images/services/tools_react.png"),
  },
  {
    id: 7,
    title: "spring boot",
    image: require("../assets/images/services/tools_spring.png"),
  },
  {
    id: 9,
    title: "vue JS",
    image: require("../assets/images/services/tools_vue.png"),
  },
];
